
import { Graphics, Filter, Container, UPDATE_PRIORITY, Ticker, Color } from "pixi.js";
import { app, fixedWidth, mainContainer, mobileView } from "../app";
import { menu } from "../screens/default";


type ViewportGraphicsOptions = {
    destContainer: Container,
    attachedHTML?: HTMLElement;
    menuFade: boolean;
    alphaMult: number;
}

export class ViewportGraphics extends Graphics {
    
    private attachedHTML: HTMLElement | undefined
    private alphaMult: number;
    private menuFade: boolean;
    public rerender: () => void;

    constructor(
        {
            destContainer,
            attachedHTML,
            menuFade,
            alphaMult
        }: ViewportGraphicsOptions
    ) {
        super();
        this.attachedHTML = attachedHTML;
        this.alphaMult = alphaMult;
        this.menuFade = menuFade;

        
        
        this.rerender = () => {
            const menuActive = menu.isActive;
            const menuMoving = menu.isMoving;
            if (!menuActive && !menuMoving) return;

            this.clear();
            const rect = this.attachedHTML?.getBoundingClientRect();
            
            if (!rect) return;
            const appHeight = app.renderer.height;
            const r = window.innerWidth / fixedWidth
            if (rect.top/r < -100 || rect.top/r > appHeight) return;

            if (this.menuFade) {
                const menuPercent = menu.droppedPercent;
                if (mobileView ){
                    const tenth = appHeight/5;
                    const topProx = Math.max(0, (rect.top/r - (menuPercent-1)*appHeight - tenth)/tenth);
                    const bottomProx = Math.max(0, (menuPercent*appHeight - rect.bottom/r)/tenth);
                    this.alpha = Math.min(1,topProx,bottomProx)* this.alphaMult
                } else {
                    this.alpha = this.alphaMult;
                }
            }
            
            if (this.alpha > 0)
            this.roundRect(rect.left / r, (rect.top+3) / r, rect.width / r, (rect.height-5) / r, 30 / r)
            .fill({ color: 0x000000, alpha: this.alphaMult });
        }

        if (this.attachedHTML) {
            this.linkToElement();
        }
        destContainer.addChild(this)
        this.zIndex = 5;
        this.zIndex = 5;

    }
    

    linkToElement() {
        app.ticker.add(this.rerender, undefined, UPDATE_PRIORITY.HIGH); //prevent desync on mobile..?
    }

    killTicker() {
        app.ticker.remove(this.rerender)
    }

}